import React from 'react';
import 'semantic-ui-css/semantic.min.css';
import { LoginForm } from '../components';
import { navigate } from 'gatsby';
import { DMTypes } from '../state/AppRedux';
import Creators from '../state/AppRedux';
import { connect } from 'react-redux';
import {
    getAuthenticationActivityIndicator,
    getLoginFormValidationMessages,
    getAuthToken
} from '../state/selectors';
import { Helmet } from 'react-helmet';

class LoginPage extends React.Component {
	constructor(props) {
		super(props);
		
		this.state = {
			showAccountRegistrationSuccessMessage: false
		};
		this.login = this.login.bind(this);
	}
	
	componentDidMount() {
		console.log('Component Did Mount Call');
		if (typeof this.props.authToken !== 'undefined' && this.props.authToken !== null) {
			this.props.logout();
			navigate('/login');
		}
		if (this.props.accountRegistered) {
			this.props.resetRegistrationState();
			this.setState({
				showAccountRegistrationSuccessMessage: true
			});
		}
	}
	
	componentDidUpdate(prevProps, prevState, snapshot) {
		console.log('Component Did Update');
		if (typeof this.props.authToken !== 'undefined' && this.props.authToken !== null) {
			navigate('/dashboard');
		}
	}
	
	componentWillUnmount() {
		this.props.stopFetching();
	}
	
	login(data) {
		console.log('login called');
		this.props.authenticate(data);
	}
	
	render() {
		return (
			<>
				<Helmet>
					<title>Login - Activities for Reading Comprehension (ARC)</title>
				</Helmet>
				<LoginForm
					login={this.login}
					loading={this.props.isLoggingIn}
					validationErrors={this.props.formValidationErrors}
				/>
			</>
		);
	}
}

const mapStateToProps = (state) => ({
	isLoggingIn: getAuthenticationActivityIndicator(state),
	formValidationErrors: getLoginFormValidationMessages(state),
	authToken: getAuthToken(state),
});

const mapDispatchToProps = (dispatch) => ({
	authenticate: (data) => dispatch(Creators.authenticate(data)),
	resetRegistrationState: () => dispatch(Creators.resetRegistrationState()),
	stopFetching: () => dispatch(Creators.stopFetching()),
	logout: () => dispatch(Creators.logout()),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(LoginPage)
